import {
  ref,
  uploadBytes,
  getDownloadURL
} from "firebase/storage";

import { storage } from "../firebase/firebaseConfig";

const subirArchivo = async ({
  archivo,
  carpeta = "general",
  emp_id,
  documentoId
}) => {

  if (!archivo) return "";

  try {

    const extension = archivo.name
      .split(".")
      .pop();

    const nombreArchivo =
      `${carpeta}/${emp_id}/${documentoId}/${Date.now()}.${extension}`;

    const storageRef = ref(storage, nombreArchivo);

    await uploadBytes(storageRef, archivo);

    const url = await getDownloadURL(storageRef);

    return url;

  } catch (error) {

    console.log("Error subir archivo:", error);

    throw error;
  }
};

export default subirArchivo;